import React, { useEffect, useState, useMemo, useRef } from 'react';

import { Grid, Typography, makeStyles, Chip } from '@material-ui/core';

import EditFields from '../common/EditFields';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => ({
  chipComponent: {
    margin: '4px',
  },
  chipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    marginTop: '24px',
  },
  fieldContainer: {
    margin: '16px 0px',
  },
}));

export default ({ ambraNamespaces, onSaveNamespaces, selectedWorkspace, isUpdating$ }) => {
  const [linkedNamespaces, setLinkedNamespaces] = useState();
  const fieldGroupRef = useRef();
  const classes = useStyles();

  useEffect(() => {
    const ids = selectedWorkspace?.linkedNamespaces?.map((namespace) => namespace.id) || [];
    setLinkedNamespaces(ids);
  }, [selectedWorkspace]);

  const handleSaveNamespaces = async () => {
    if (!onSaveNamespaces || typeof onSaveNamespaces !== 'function') return;
    const data = await fieldGroupRef.current.getValidData();
    const workspaceId = selectedWorkspace.id;
    onSaveNamespaces(workspaceId, data.namespaceIds);
  };

  const fieldGroup = useMemo(
    () => [
      {
        className: 'custom-height force',
        items: ambraNamespaces || [],
        multiple: true,
        name: 'namespaceIds',
        renderValue: (selected) => {
          const chips = selected.map((sl) => {
            const data = ambraNamespaces.filter((aN) => aN.value === sl);
            return <Chip className={classes.chipComponent} size="small" variant="outlined" key={sl} label={data[0]?.label} />;
          });
          return <div className={classes.chipsContainer}>{chips}</div>;
        },
        required: true,
        type: 'select',
      },
    ],
    [ambraNamespaces, classes]
  );

  return (
    <Grid container className={classes.container}>
      <Grid item container className={classes.fieldContainer}>
        <Typography variant="h6" align="left">
          Linked Namespaces
        </Typography>

        <EditFields ref={fieldGroupRef} fields={fieldGroup} data={{ namespaceIds: linkedNamespaces }} labelPosition="top" useAutoFocus={false} />

        <LoadingButton color="primary" loading$={isUpdating$} style={{ marginTop: '0' }} variant="contained" size="medium" onClick={handleSaveNamespaces}>
          Save Namespaces
        </LoadingButton>
      </Grid>
    </Grid>
  );
};
